import { HourRange, GroupedRecordsByStartTime } from "./calendar";
import React, { useEffect, useRef } from 'react';

interface ScheduleDayViewProps {
	dataSet: any[];
	selectedDate: string | Date;
	hourHeight: number;
	startingHour: string;
	endingHour: string;
	handleAvailabilityClick: (record: any) => void;
	handleEntryClick: (record: any) => void;
}

const ScheduleDayView: React.FC<ScheduleDayViewProps> = (props) => {
	const {
		dataSet,
		selectedDate,
		hourHeight,
		startingHour,
		endingHour,
		handleAvailabilityClick,
		handleEntryClick,
	} = props;

	const scope = 'day';
	let availability: any[] = [];
	let entries: any[] = [];

	const result = dataSet.filter((obj: any) => {
		return obj.date === selectedDate;
	});

	if (result.length !== 0) {
		availability = Date.parse(result[0].date) >= Date.parse(new Date().toLocaleDateString('fr-CA')) ? result[0].availability : [];
		entries = result[0].entries;
	}

	// using hooks to set starting scroll position
	const setStartingScrollPosition = hourHeight * 7; // we want the 24-hour view to be scrolled to 7am on initial render
	const scrollElement = useRef < HTMLDivElement > (null);

	const scrollToStartingPosition = () => {
		if (scrollElement.current) {
			scrollElement.current.scrollTop = setStartingScrollPosition;
		}
	};

	useEffect(() => {
		scrollToStartingPosition();
	}, []);

	return (
		<main>
			<section className="calendar day-view">
				<div className="calendar-body" ref={scrollElement}>
					<HourRange startHour={'2024-01-01T' + startingHour} endHour={'2024-01-01T' + endingHour} hourHeight={hourHeight} scope={scope} />
					<div className="day-view-slots-container">
						<GroupedRecordsByStartTime
							dataType={'availability'}
							hourHeight={hourHeight}
							startingHour={startingHour}
							endingHour={endingHour}
							records={availability}
							onRecordClick={handleAvailabilityClick}
						/>
						<GroupedRecordsByStartTime
							dataType={'entries'}
							hourHeight={hourHeight}
							startingHour={startingHour}
							endingHour={endingHour}
							records={entries}
							onRecordClick={handleEntryClick}
						/>
					</div>
				</div>
			</section>
		</main>
	);
};

export default ScheduleDayView;